import { TableColumnDisplayType, TableColumnHeaderDisplayType } from '@kurtosys/ksys-app-components/dist/components/base/Table/models';
import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	token: 'f09e99df-de0c-456c-ac04-ceb6b39a005c',
	culture: {
		base: 'Default',
		default: 'en-GB',
	},
	core: {
		serviceUrl: 'https://api-rel.fundpress.io',
		skeletonLoaders: {
			variables: [
				{
					key: 'fillColor',
					value: '#dddddd',
				},
			],
			loaders: [
				{
					id: 'ksys-app-start',
					breakpoints: [
						{
							minWidthInPixels: 0,
							style: {
								height: '86px',
							},
							children: [
								{
									'fill': '{fillColor}',
									'x': '0px',
									'y': '11.90625px',
									'height': '28px',
									'width': '100%',
								},
								{
									'fill': '{fillColor}',
									'x': '0px',
									'y': '59.8125px',
									'height': '18px',
									'width': '100%',
								},
							],
						},
					],
				},
			],
		},
	},
	data: {
		context: {

		},
	},
	components: {
		app: {
			noDataOptions: {
				hide: false,
				hideRow: false,
			},
		},
		card: {
		},
		table: {
			dynamicRows: {
				queryOptionsType: 'entities',
				queryId: 'shareClass',
				transforms: [
					{
						transformOptionsType: 'map',
						mapTransformOptions: {
							entity: {
								load: true,
							},
							transforms: [
								{
									transformOptionsType: 'query',
									queryTransformOptions: {
										queryOptionsType: 'object',
										fields: [
											{
												name: 'fundId',
												query: {
													queryOptionsType: 'property',
													entityType: 'CLSS',
													code: 'fund_id',
												},
											},
											{
												name: 'isin',
												query: {
													queryOptionsType: 'property',
													entityType: 'CLSS',
													code: 'isin',
												},
											},
											{
												name: 'name',
												query: {
													queryOptionsType: 'property',
													entityType: 'CLSS',
													code: 'class_name',
												},
											},
											{
												name: 'verdict',
												query: {
													queryOptionsType: 'property',
													entityType: 'CLSS',
													code: 'class_value_score',
												},
											},
											{
												name: 'perf3Y',
												query: {
													queryOptionsType: 'statistics',
													entityType: 'CLSS',
													code: 'perf_3year',
													key: 'value',
													index: 0,
												},
											},
											{
												name: 'benchmarkPerf3Y',
												query: {
													queryOptionsType: 'statistics',
													entityType: 'CLSS',
													code: 'perf_3year',
													key: 'benchmark_value',
													index: 0,
												},
											},
											{
												name: 'relativePerf3Y',
												query: {
													queryOptionsType: 'statistics',
													entityType: 'CLSS',
													code: 'perf_after_fees',
													key: 'rel_3yr',
													index: 0,
												},
											},
											{
												name: 'investmentScore',
												query: {
													queryOptionsType: 'statistics',
													entityType: 'CLSS',
													code: 'fees_scores_ranks',
													key: 'investment_score',
													index: 0,
												},
											},
											{
												name: 'ocfValue',
												query: {
													queryOptionsType: 'statistics',
													entityType: 'CLSS',
													code: 'ongoing_charges',
													key: 'value',
													index: 0,
												},
											},
											{
												name: 'ocfAmount',
												query: {
													queryOptionsType: 'statistics',
													entityType: 'CLSS',
													code: 'ongoing_charges',
													key: 'ocf_gbp',
													index: 0,
												},
											},
											{
												name: 'totalInvestmentCostValue',
												query: {
													queryOptionsType: 'statistics',
													entityType: 'CLSS',
													code: 'fees_scores_ranks',
													key: 'total_investment_cost',
													index: 0,
												},
											},
											{
												name: 'totalInvestmentCostAmount',
												query: {
													queryOptionsType: 'statistics',
													entityType: 'CLSS',
													code: 'fees_scores_ranks',
													key: 'tic_amount',
													index: 0,
												},
											},
											{
												name: 'costScore',
												query: {
													queryOptionsType: 'statistics',
													entityType: 'CLSS',
													code: 'fees_scores_ranks',
													key: 'cost_score',
													index: 0,
												},
											},
											{
												name: 'serviceRating',
												query: {
													queryOptionsType: 'statistics',
													entityType: 'CLSS',
													code: 'fees_scores_ranks',
													key: 'service_score',
													index: 0,
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
			props: {
				cardListProps: {
					itemStyle: 'justified',
				},
				columns: [
					{
						id: 'name',
						key: 'name',
						hide: false,
						headerDisplay: {
							type: TableColumnHeaderDisplayType.scaleLegend,
							options: {
								scaleLegend: {
									values: ['Poor', 'Moderate', 'Good', 'Outstanding'],
								},
							},
						},
						display: {
							type: TableColumnDisplayType.link,
							options: {
								link: {
									redirect: {
										defaultUrl: '/',
										options: {
											preserveOrigin: true,
											preserveOriginPath: false,
											urlEndpoint: ['my-endpoint'],
											queryStringParams: [
												{
													key: 'fundId',
													value: '{row.fundId}',
												},
											],
										},
									},
								},
							},
						},
					},
					{
						id: 'verdict',
						key: 'verdict',
						header: 'Verdict',
						hide: false,
						display: {
							type: TableColumnDisplayType.scale,
							options: {
								scale: {
									max: 4,
								},
							},
						},
					},
					{
						id: 'isin',
						key: 'isin',
						header: 'ISIN',
					},
					{
						id: 'perf3Y',
						key: 'perf3Y',
						header: 'Share Class',
						headerGroupId: 'annualisedPerformance',
						headCellClasses: [
							{
								className: 'ksys-header-performance',
							},
						],
					},
					{
						id: 'benchmarkPerf3Y',
						key: 'benchmarkPerf3Y',
						header: 'Benchmark (net of ETF fees)',
						headerGroupId: 'annualisedPerformance',
						headCellClasses: [
							{
								className: 'ksys-header-performance',
							},
						],
					},
					{
						id: 'relativePerf3Y',
						key: 'relativePerf3Y',
						header: 'Relative',
						headerGroupId: 'annualisedPerformance',
						headCellClasses: [
							{
								className: 'ksys-header-performance',
							},
						],
					},
					{
						id: 'investmentScore',
						key: 'investmentScore',
						header: 'Investment Score',
						headerGroupId: 'performance',
						hide: false,
						display: {
							type: TableColumnDisplayType.scale,
							options: {
								scale: {
									max: 4,
								},
							},
						},
						headCellClasses: [
							{
								className: 'ksys-header-performance',
							},
						],
					},
					{
						id: 'ocfValue',
						key: 'ocfValue',
						header: 'Value',
						headerGroupId: 'ocf',
						headCellClasses: [
							{
								className: 'ksys-header-cost-and-charges',
							},
						],
					},
					{
						id: 'ocfAmount',
						key: 'ocfAmount',
						header: 'Amount',
						headerGroupId: 'ocf',
						headCellClasses: [
							{
								className: 'ksys-header-cost-and-charges',
							},
						],
					},
					{
						id: 'totalInvestmentCostValue',
						key: 'totalInvestmentCostValue',
						header: 'Value',
						headerGroupId: 'totalInvestmentCost',
						headCellClasses: [
							{
								className: 'ksys-header-cost-and-charges',
							},
						],
					},
					{
						id: 'totalInvestmentCostAmount',
						key: 'totalInvestmentCostAmount',
						header: 'Amount',
						headerGroupId: 'totalInvestmentCost',
						headCellClasses: [
							{
								className: 'ksys-header-cost-and-charges',
							},
						],
					},
					{
						id: 'costScore',
						key: 'costScore',
						header: 'Cost Score',
						headerGroupId: 'costAndCharges',
						hide: false,
						display: {
							type: TableColumnDisplayType.scale,
							options: {
								scale: {
									max: 4,
								},
							},
						},
						headCellClasses: [
							{
								className: 'ksys-header-cost-and-charges',
							},
						],
					},
					{
						id: 'serviceRating',
						key: 'serviceRating',
						header: 'Rating',
						headerGroupId: 'service',
						hide: false,
						display: {
							type: TableColumnDisplayType.scale,
							options: {
								scale: {
									max: 4,
								},
							},
						},
						headCellClasses: [
							{
								className: 'ksys-header-service',
							},
						],
					},
				],
				headerGroups: [
					{
						id: 'performance',
						header: 'Performance',
						headCellClasses: [
							{
								className: 'ksys-header-performance',
							},
						],
					},
					{
						parentId: 'performance',
						id: 'annualisedPerformance',
						header: '3yr Annualised Performance',
						headCellClasses: [
							{
								className: 'ksys-header-performance',
							},
						],
					},
					{
						id: 'costAndCharges',
						header: 'Costs and Charges % plus Rank vs Peers',
						headCellClasses: [
							{
								className: 'ksys-header-cost-and-charges',
							},
						],
					},
					{
						parentId: 'costAndCharges',
						id: 'ocf',
						header: 'OCF',
						headCellClasses: [
							{
								className: 'ksys-header-cost-and-charges',
							},
						],
					},
					{
						parentId: 'costAndCharges',
						id: 'totalInvestmentCost',
						header: 'Total Investment Cost',
						headCellClasses: [
							{
								className: 'ksys-header-cost-and-charges',
							},
						],
					},
					{
						id: 'service',
						header: 'Service',
						headCellClasses: [
							{
								className: 'ksys-header-service',
							},
						],
					},
				],
				placeholder: '-',
				disclaimersProps: {
					disclaimers: [
						{
							text: 'This is a disclaimer that we want to make sure only goes to the end or last table',
						},
					],
				},
			},
		},
	},
	assetOverrides: {
		base: {
			tooltip: {
				defaultIcon: 'InformationIcon.svg',
			},
		},
	},
};
